import script from "./SearchResultsHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchResultsHeader.vue?vue&type=script&lang=ts&setup=true"

import "./SearchResultsHeader.vue?vue&type=style&index=0&id=3107cd9c&lang=scss"

const __exports__ = script;

export default __exports__
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtnToggle,QTooltip,QBtn,QField});
